import { useLocation } from 'react-router-dom';

export default function useIsOnPage(urls: string[]) {
  const location = useLocation();
  return urls.some(url => location.pathname.includes(url));
}
